/**
 * tRPC delivers Postgres `timestamp` columns as `Date` (SuperJSON), while the
 * legacy GraphQL `timestamptz`/`uuid` scalars are strings. These coercions let
 * the tRPC twins reshape a data-layer row into the exact `tppGetResponses` /
 * `tppGetResponseById` subscription shape so the pages read identical data on
 * both flag paths (RSP-6570).
 */

/** Required timestamp → ISO string. */
export const toIso = (value: Date | string): string =>
  value instanceof Date ? value.toISOString() : value;

/** Nullable timestamp → ISO string | null (GraphQL models absent as optional). */
export const toIsoOrNull = (
  value: Date | string | null | undefined
): string | null | undefined =>
  value == null ? value : value instanceof Date ? value.toISOString() : value;
